export enum GlobalEvent {
	PORTFOLIO_OPTIMIZED = 'PORTFOLIO_OPTIMIZED',
	ENTITY_EXPLORER_ENTITY_SELECTION = 'ENTITY_EXPLORER_ENTITY_SELECTION',
}